<template>
  <div class="profit-setting">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <!--推广员收益设置-->
      <div class="common-form">推广员收益设置</div>
      
      <el-form-item label="一级推广收益比例">
        <el-input v-model="form.promoter_level1_rate" class="max-w460">
          <template slot="append">%</template>
        </el-input>
        <div class="tips">推广员直接推广用户获得的收益比例</div>
      </el-form-item>
      
      <el-form-item label="二级推广收益比例">
        <el-input v-model="form.promoter_level2_rate" class="max-w460">
          <template slot="append">%</template>
        </el-input>
        <div class="tips">推广员间接推广用户获得的收益比例</div>
      </el-form-item>
      
      <el-form-item label="发展推广员一级奖励">
        <el-input v-model="form.promoter_develop_level1" class="max-w460">
          <template slot="append">元</template>
        </el-input>
        <div class="tips">推广员直接发展新推广员获得的奖励金额</div>
      </el-form-item>
      
      <el-form-item label="发展推广员二级奖励">
        <el-input v-model="form.promoter_develop_level2" class="max-w460">
          <template slot="append">元</template>
        </el-input>
        <div class="tips">推广员间接发展新推广员获得的奖励金额</div>
      </el-form-item>

      <!--城市合伙人收益设置-->
      <div class="common-form">城市合伙人收益分红</div>
      <el-form-item label="城市合伙人推广一级奖励">
        <el-input v-model="form.partner_develop1_rate" class="max-w460">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
      
      <el-form-item label="城市合伙人推广二级奖励">
        <el-input v-model="form.partner_develop2_rate" class="max-w460">
          <template slot="append">%</template>
        </el-input>
      </el-form-item>
      
      <el-form-item label="一级分红比例">
        <el-input v-model="form.partner_level1_rate" class="max-w460">
          <template slot="append">%</template>
        </el-input>
        <div class="tips">城市合伙人直接推广收益的分红比例</div>
      </el-form-item>
      
      <el-form-item label="二级分红比例">
        <el-input v-model="form.partner_level2_rate" class="max-w460">
          <template slot="append">%</template>
        </el-input>
        <div class="tips">城市合伙人间接推广收益的分红比例</div>
      </el-form-item>

      <!-- <el-form-item label="证书分成比例">
        <el-input v-model="form.certificate_rate" class="max-w460">
          <template slot="append">%</template>
        </el-input>
        <div class="tips">推广员推广证书获得的缴费金额分成比例</div>
      </el-form-item> -->

<el-form-item label="课程缴费分成比例">
        <el-input v-model="form.course_rate" class="max-w460">
          <template slot="append">%</template>
        </el-input>
        <div class="tips">推广员推广课程获得的缴费金额分成比例</div>
      </el-form-item>
      
      

      <!--校园服务平台设置-->
      <div class="common-form">校园服务平台设置</div>
      
      <el-form-item label="平台服务费">
        <el-input v-model="form.platform_fee" class="max-w460">
          <template slot="append">元</template>
        </el-input>
        <div class="tips">每笔订单平台扣除的服务费用</div>
      </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
        <el-button @click="resetForm">重置</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import SettingApi from '@/api/setting.js';

export default {
  data() {
    return {
      /*form表单数据*/
      form: {
        // 推广员收益
        promoter_level1_rate: '', // 一级推广收益比例
        promoter_level2_rate: '', // 二级推广收益比例
        partner_develop1_rate:'',
        partner_develop2_rate:'',
        certificate_rate:'',
        promoter_develop_level1: '', // 发展推广员一级奖励
        promoter_develop_level2: '', // 发展推广员二级奖励
        
        // 城市合伙人收益
        partner_level1_rate: '', // 一级分红比例
        partner_level2_rate: '', // 二级分红比例
        
        // 职场课程
        course_rate: '', // 课程缴费分成比例
        
        // 校园服务平台
        platform_fee: '' // 平台服务费
      },
      loading: false,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    // 获取分润设置数据
    getData() {
      let self = this;
      SettingApi.profitDetail({}, true)
        .then(data => {
          let profitData = data.data.vars.values;
          // 填充表单数据
          Object.keys(self.form).forEach(key => {
            if (profitData[key] !== undefined) {
              self.form[key] = profitData[key];
            }
          });
        })
        .catch(error => {
          console.error('获取分润设置失败:', error);
        });
    },
    
    // 提交表单
    onSubmit() {
      let self = this;
      
      // 表单验证
      if (!this.validateForm()) {
        return;
      }
      
      self.loading = true;
      let params = this.form;
      
      SettingApi.editProfit(params, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: '恭喜您，分润模式设置成功',
            type: 'success'
          });
        })
        .catch(error => {
          self.loading = false;
          self.$message.error('设置失败，请重试');
        });
    },
    
    // 表单验证
    validateForm() {
      // 验证百分比字段 (0-100之间)
      const percentageFields = [
        'promoter_level1_rate', 
        'promoter_level2_rate', 
        'partner_level1_rate', 
        'partner_level2_rate',
        'course_rate'
      ];
      
      for (let field of percentageFields) {
        const value = parseFloat(this.form[field]);
        if (isNaN(value) || value < 0 || value > 100) {
          this.$message.error(`${this.getFieldLabel(field)}必须在0-100之间`);
          return false;
        }
      }
      
      // 验证金额字段 (非负)
      const amountFields = [
        'promoter_develop_level1',
        'promoter_develop_level2',
        'platform_fee'
      ];
      
      for (let field of amountFields) {
        const value = parseFloat(this.form[field]);
        if (isNaN(value) || value < 0) {
          this.$message.error(`${this.getFieldLabel(field)}必须为非负数`);
          return false;
        }
      }
      
      return true;
    },
    
    // 获取字段标签
    getFieldLabel(field) {
      const labelMap = {
        promoter_level1_rate: '一级推广收益比例',
        promoter_level2_rate: '二级推广收益比例',
        promoter_develop_level1: '发展推广员一级奖励',
        promoter_develop_level2: '发展推广员二级奖励',
        partner_level1_rate: '一级分红比例',
        partner_level2_rate: '二级分红比例',
        course_rate: '课程缴费分成比例',
        platform_fee: '平台服务费'
      };
      
      return labelMap[field] || field;
    },
    
    // 重置表单
    resetForm() {
      this.$refs.form.resetFields();
      this.getData(); // 重新获取初始数据
    }
  }
};
</script>

<style scoped>
.profit-setting {
  padding: 20px;
}

.common-form {
  font-size: 16px;
  font-weight: bold;
  margin: 20px 0 15px 0;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.max-w460 {
  max-width: 460px;
}

.tips {
  color: #909399;
  font-size: 12px;
  margin-top: 5px;
}

.common-button-wrapper {
  margin-top: 30px;
  padding-left: 200px;
}
</style>


// WEBPACK FOOTER //
// src/views/user/profit/index.vue